import FIELDS_SORT_OPTIONS from 'constants/newFlowFieldsSortOptions';

const initialState = {
  list: {
    isLoading: false,
    error: '',
    sortOptions: FIELDS_SORT_OPTIONS,
    paginationOptions: {
      page: 1,
      size: 50,
      attributes__name__icontains: '',
      ordering: 'attributes__name',
    },
    data: [],
    count: 0,
    totalCount: 0,
  },
  all: {
    isLoading: false,
    error: '',
    data: [],
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  add: {
    isLoading: false,
    error: '',
    data: {},
  },
  delete: {
    isLoading: false,
    error: '',
    hasDependencies: false,
    data: {},
  },
};

export default initialState;
